import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Box, Button, Typography } from '@mui/material';
import useWalletContext from 'hooks/useWalletContext';

function FallbackUI() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
      gap={2}
      p={3}
    >
      <Typography variant="h5" fontWeight={600}>
        Something went wrong
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        An unexpected error occurred. Please try refreshing the page.
      </Typography>
      <Box display="flex" gap={2} mt={1}>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Refresh Page
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            window.history.back();
            setTimeout(() => window.location.reload(), 100);
          }}
        >
          Go Back
        </Button>
      </Box>
    </Box>
  );
}

export function SentryUserContext() {
  const { address, isConnected } = useWalletContext();

  useEffect(() => {
    if (isConnected && address) {
      Sentry.setUser({ id: address });
    } else {
      Sentry.setUser(null);
    }
  }, [isConnected, address]);

  return null;
}

function ErrorBoundary({ children }) {
  return <Sentry.ErrorBoundary fallback={<FallbackUI />}>{children}</Sentry.ErrorBoundary>;
}

export default ErrorBoundary;
